import React, { useState } from "react";
import { context } from "./context";

const GlobalState = ({ children }) => {
    const [ostan, setOstan] = useState(true);
    const [shahrestan, setShahrestan] = useState(false);
    const [shahr, setShahr] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [provinces, setProvinces] = useState([]);
    const [country, setCountry] = useState([]);
    const [city, setCity] = useState([]);
    const [village, setVillage] = useState([]);
    const [forceUpdate, setForceUpdate] = useState();
    const [ostanName, setOstanName] = useState("");
    const [ostanIcon, setOstanIcon] = useState("");
    const [ostanColor, setOstanColor] = useState("");
    const [ostanId, setOstanId] = useState();
    const [shahrestanName, setShahrestanName] = useState("");
    const [shahrestanIcon, setShahrestanIcon] = useState("");
    const [shahrestanColor, setShahrestanColor] = useState("");
    const [cityColor, setCityColor] = useState("");
    const [cityName, setCityName] = useState("");
    const [cityTag, setCityTag] = useState([]);
    const [cityIcon, setCityIcon] = useState("");
    const [shahrestanId, setShahrestanId] = useState();
    const [parentOstanId, setParentOstanId] = useState();
    const [countryId, setCountryId] = useState();
    const [cityId, setCityId] = useState();
    const [isEditShow, setIsEditShow] = useState(false);
    //place categories
    const [placeCategories, setPlaceCategories] = useState([]);
    const [placeName, setPlaceName] = useState("");
    const [placeId, setPlaceId] = useState("");
    const [placeIcon, setPlaceIcon] = useState("");
    const [placeTag, setPlaceTag] = useState([]);
    const [placeMapIcon, setPlaceMapIcon] = useState("");
    const [placeColor, setPlaceColor] = useState("#FFFFFF");
    const [isAddSubset, setIsAddSubset] = useState(false);
    const [child, setChild] = useState();
    //places
    const [dataPlaces, setDataPlaces] = useState([]);
    const [addNamePlace, setAddNamePlace] = useState();
    const [addPhonePlace, setAddPhonePlace] = useState();
    const [addAddressPlace, setAddAddressPlace] = useState();
    const [addLinkPlace, setAddLinkPlace] = useState();
    const [addKindLinkPlace, setAddKindLinkPlace] = useState("web");
    const [addUrlPlace, setAddUrlPlace] = useState();
    const [isProvinceSelected, setIsProvinceSelected] = useState(false);
    const [isCountrySelected, setIsCountrySelected] = useState(false);
    const [isCategorySelected, setIsCategorySelected] = useState(false);
    const [selectedPlaceId, setSelectedPlaceId] = useState();
    const [placesId, setPlacesId] = useState();
    const [selectedProvince, setSelectedProvince] = useState();
    const [selectedCountry, setSelectedCountry] = useState();
    const [selectedCategoryId, setSelectedCategoryId] = useState();
    const [selectedSubCategoryId, setSelectedSubCategoryId] = useState("");
    const [selectedCityId, setSelectedCityId] = useState();
    const [selectedPlaceProvinceId, setSelectedPlaceProvinceId] = useState();
    // const [selectedCityId, setSelectedCityId] = useState();
    // const [selectedCityId, setSelectedCityId] = useState();

    // select location map
    const [latLng, setLatLng] = useState();
    //text editor
    const [textEditorShow, setTextEditorShow] = useState(false);
    //pladeDetailForm tag
    const [placeFormTag, setPlaceFormTag] = useState([]);
    const [linkTags, setLinkTags] = useState([]);
    //texteditor
    const [textEditorHTML, setTextEditorHTML] = useState("");
    //content
    const [contentId, setContentId] = useState();
    const [dataContents, setDataContents] = useState([]);
    const [addNameContent, setAddNameContent] = useState();
    const [addPhoneContent, setAddPhoneContent] = useState();
    const [addAddressContent, setAddAddressContent] = useState();
    const [addLinkContent, setAddLinkContent] = useState();
    const [addKindLinkContent, setAddKindLinkContent] = useState("web");
    const [addUrlContent, setAddUrlContent] = useState();
    const [selectedContentId, setSelectedContentId] = useState();
    const [editedProvince, setEditedProvince] = useState();
    const [editedCountry, setEditedCountry] = useState();
    const [editedCity, setEditedCity] = useState();
    const [editedCategory, setEditedCategory] = useState();
    const [editedSubCategory, setEditedSubCategory] = useState();
    // fp
    const [fpHash, setFpHash] = useState("");
    // upload
    const [fileList, setFileList] = useState([]);
    const [coverPic, setCoverPic] = useState([]);
    const [fileListIds, setFileListIds] = useState([]);
    const [coverPicId, setCoverPicId] = useState("");
    // Linkestan
    const [selectedLinkId, setSelectedLinkId] = useState();
    const [linkestanTags, setLinkestanTags] = useState([]);
    const [linkTitle, setLinkTitle] = useState("");
    const [newLinks, setNewLinks] = useState([]);
    const [linkColor, setLinkColor] = useState();
    const [linkIcon, setLinkIcon] = useState();
    const [linkUrl, setLinkUrl] = useState();
    const [linkMedia, setLinkMedia] = useState([]);
    const [linkMediaId, setLinkMediaId] = useState([]);
    const [linkCover, setLinkCover] = useState([]);
    const [linkCoverId, setLinkCoverId] = useState("");
    const [linkestanIcon, setLinkestanIcon] = useState();
    const [titleOfLink, setTitleOfLink] = useState("");

    // News
    const [selectedNewsId, setSelectedNewsId] = useState();
    const [newsTags, setNewsTags] = useState([]);
    const [newsTitle, setNewsTitle] = useState("");
    const [newsLinks, setNewsLinks] = useState([]);
    const [newsLinkColor, setNewsLinkColor] = useState();
    const [newsLinkIcon, setNewsLinkIcon] = useState();
    const [newsLinkUrl, setNewsLinkUrl] = useState();
    const [newsMedia, setNewsMedia] = useState([]);
    const [newsMediaId, setNewsMediaId] = useState([]);
    const [newsCover, setNewsCover] = useState();
    const [newsCoverId, setNewsCoverId] = useState("");
    const [newstitleUrl, setNewstitleUrl] = useState("");
    // Event
    const [selectedEventId, setSelectedEventId] = useState();
    const [eventTags, setEventTags] = useState([]);
    const [eventTitle, setEventTitle] = useState("");
    const [eventLinks, setEventLinks] = useState([]);
    const [eventLinkColor, setEventLinkColor] = useState();
    const [eventLinkIcon, setEventLinkIcon] = useState();
    const [eventLinkUrl, setEventLinkUrl] = useState();
    const [eventMedia, setEventMedia] = useState([]);
    const [eventMediaId, setEventMediaId] = useState([]);
    const [eventCover, setEventCover] = useState([]);
    const [eventCoverId, setEventCoverId] = useState("");
    const [eventLinktitleUrl, setEventLinktitleUrl] = useState("");
    const [eventStartDate, setEventStartDate] = useState();
    const [eventEndDate, setEventEndDate] = useState();
    //textEditor uploader
    const [linkAddress, setLinkAddress] = useState();
    //FeedBack
    const [selectedFeedBackId, setSelectedFeedBackId] = useState();
    const [feedBackStartDate, setFeedBackStartDate] = useState();
    const [feedBackEndDate, setFeedBackEndDate] = useState();
    const [feedBackStartText, setFeedBackStartText] = useState();
    const [feedBackEndText, setFeedBackEndText] = useState();
    const [feedBackStepTwoId, setFeedBackStepTwoId] = useState();
    const [feedBackQuestionText, setFeedBackQuestionText] = useState();
    const [feedBackAnswers, setFeedBackAnswers] = useState([]);
    const [feedBackData, setFeedBackData] = useState([]);
    const [feedBackTitle, setFeedBackTitle] = useState("");

    //Interaction
    const [isInteractionModalOpen, setIsInteractionModalOpen] = useState(false);
    //Notice
    const [isNoticeModalOpen, setIsNoticeModalOpen] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [titleInput, setTitleInput] = useState("");
    const [dataInput, setDataInput] = useState("");

    //admin
    const [isAdminModalOpen, setIsAdminModalOpen] = useState(false);
    // TravelSuggestion
    const [selectedTravelId, setSelectedTravelId] = useState("");
    const [travelTitle, setTravelTitle] = useState("");
    const [travelPlaces, setTravelPlaces] = useState([]);
    const [travelContent, setTravelContent] = useState([]);
    const [travelGeo, setTravelGeo] = useState([]);
    const [travelTags, setTravelTags] = useState([]);
    const [travelTime, setTravelTime] = useState([]);
    const [travelMedia, setTravelMedia] = useState([]);
    const [travelMediaId, setTravelMediaId] = useState([]);
    const [travelCover, setTravelCover] = useState([]);
    const [travelCoverId, setTravelCoverId] = useState("");
    //discount
    const [discountTitle, setDiscountTitle] = useState("");
    const [discountDescription, setDiscountDescription] = useState("");
    const [discountLinkUrl, setDiscountLinkUrl] = useState("");
    const [discountLinkTitle, setDiscountLinkTitle] = useState("");
    const [discountLinks, setDiscountLinks] = useState([]);
    const [discountTags, setDiscountTags] = useState([]);
    const [selectedDiscountId, setSelectedDiscountId] = useState();
    const [discountCoverId, setDiscountCoverId] = useState("");
    const [discountCover, setDiscountCover] = useState([]);
    const [discountMedia, setDiscountMedia] = useState([]);
    const [discountMediaId, setDiscountMediaId] = useState([]);

    // Gallery
    const [selectedGalleryId, setSelectedGalleryId] = useState("");
    const [galleryTitle, setGalleryTitle] = useState("");
    const [galleryDescription, setGalleryDescription] = useState("");
    const [galleryIcon, setGalleryIcon] = useState("");
    const [galleryColor, setGalleryColor] = useState("");
    const [galleryTags, setGalleryTags] = useState([]);
    const [galleryMedia, setGalleryMedia] = useState([]);
    const [galleryMediaId, setGalleryMediaId] = useState([]);
    // Ads
    const [selectedAdId, setSelectedAdId] = useState("");
    const [adPriority, setAdPriority] = useState();
    const [adLink, setAdLink] = useState("");
    const [adTags, setAdTags] = useState([]);
    const [adPosition, setAdPosition] = useState("");
    const [adLimit, setAdLimit] = useState();
    const [adStartDate, setAdStartDate] = useState();
    const [adEndDate, setAdEndDate] = useState();
    const [adTitle, setAdTitle] = useState("");
    const [adDescription, setAdDescription] = useState("");
    const [adCover, setAdCover] = useState([]);
    const [adCoverId, setAdCoverId] = useState();
    const [adNumOfSlide, setAdNumOfSlide] = useState();

    return (
        <context.Provider
            value={{
                ostan,
                setOstan,
                shahrestan,
                setShahrestan,
                shahr,
                setShahr,
                isModalOpen,
                setIsModalOpen,
                provinces,
                setProvinces,
                forceUpdate,
                setForceUpdate,
                ostanColor,
                setOstanColor,
                ostanIcon,
                setOstanIcon,
                ostanName,
                setOstanName,
                ostanId,
                setOstanId,
                isEditShow,
                setIsEditShow,
                country,
                setCountry,
                parentOstanId,
                setParentOstanId,
                countryId,
                setCountryId,
                shahrestanName,
                setShahrestanName,
                shahrestanIcon,
                setShahrestanIcon,
                shahrestanColor,
                setShahrestanColor,
                shahrestanId,
                setShahrestanId,
                city,
                setCity,
                cityId,
                setCityId,
                cityColor,
                setCityColor,
                cityName,
                setCityName,
                cityTag,
                setCityTag,
                cityIcon,
                setCityIcon,
                village,
                setVillage,
                placeCategories,
                setPlaceCategories,
                placeName,
                setPlaceName,
                placeIcon,
                setPlaceIcon,
                placeTag,
                setPlaceTag,
                placeMapIcon,
                setPlaceMapIcon,
                placeId,
                setPlaceId,
                placeColor,
                setPlaceColor,
                isAddSubset,
                setIsAddSubset,
                child,
                setChild,
                dataPlaces,
                setDataPlaces,
                addNamePlace,
                setAddNamePlace,
                addUrlPlace,
                setAddUrlPlace,
                addLinkPlace,
                setAddLinkPlace,
                addAddressPlace,
                setAddAddressPlace,
                addPhonePlace,
                setAddPhonePlace,
                latLng,
                setLatLng,
                textEditorShow,
                setTextEditorShow,
                placeFormTag,
                setPlaceFormTag,
                linkTags,
                setLinkTags,
                addKindLinkPlace,
                setAddKindLinkPlace,
                isProvinceSelected,
                setIsProvinceSelected,
                isCountrySelected,
                setIsCountrySelected,
                isCategorySelected,
                setIsCategorySelected,
                textEditorHTML,
                setTextEditorHTML,
                selectedPlaceId,
                setSelectedPlaceId,
                selectedContentId,
                setSelectedContentId,
                addUrlContent,
                setAddUrlContent,
                addKindLinkContent,
                setAddKindLinkContent,
                addLinkContent,
                setAddLinkContent,
                addAddressContent,
                setAddAddressContent,
                addPhoneContent,
                setAddPhoneContent,
                addNameContent,
                setAddNameContent,
                dataContents,
                setDataContents,
                fpHash,
                setFpHash,
                placesId,
                setPlacesId,
                selectedCityId,
                setSelectedCityId,
                selectedCategoryId,
                setSelectedCategoryId,
                selectedCountry,
                setSelectedCountry,
                selectedProvince,
                setSelectedProvince,
                selectedSubCategoryId,
                setSelectedSubCategoryId,
                editedCity,
                setEditedCity,
                editedCountry,
                setEditedCountry,
                editedProvince,
                setEditedProvince,
                editedSubCategory,
                setEditedSubCategory,
                editedCategory,
                setEditedCategory,
                contentId,
                setContentId,
                fileList,
                setFileList,
                coverPic,
                setCoverPic,
                coverPicId,
                setCoverPicId,
                fileListIds,
                setFileListIds,
                selectedPlaceProvinceId,
                setSelectedPlaceProvinceId,
                selectedLinkId,
                setSelectedLinkId,
                linkestanTags,
                setLinkestanTags,
                linkUrl,
                setLinkUrl,
                linkIcon,
                setLinkIcon,
                linkColor,
                setLinkColor,
                newLinks,
                setNewLinks,
                linkTitle,
                setLinkTitle,
                linkCoverId,
                setLinkCoverId,
                linkCover,
                setLinkCover,
                linkMediaId,
                setLinkMediaId,
                linkMedia,
                setLinkMedia,
                linkestanIcon,
                setLinkestanIcon,
                selectedNewsId,
                setSelectedNewsId,
                newsTags,
                setNewsTags,
                newsTitle,
                setNewsTitle,
                newsLinks,
                setNewsLinks,
                newsLinkColor,
                setNewsLinkColor,
                newsLinkIcon,
                setNewsLinkIcon,
                newsLinkUrl,
                setNewsLinkUrl,
                newsMedia,
                setNewsMedia,
                newsMediaId,
                setNewsMediaId,
                newsCover,
                setNewsCover,
                newsCoverId,
                setNewsCoverId,
                eventStartDate,
                setEventStartDate,
                eventEndDate,
                setEventEndDate,
                eventCoverId,
                setEventCoverId,
                eventCover,
                setEventCover,
                eventMediaId,
                setEventMediaId,
                eventMedia,
                setEventMedia,
                eventLinkUrl,
                setEventLinkUrl,
                eventLinkIcon,
                setEventLinkIcon,
                eventLinkColor,
                setEventLinkColor,
                eventLinks,
                setEventLinks,
                eventTitle,
                setEventTitle,
                eventTags,
                setEventTags,
                selectedEventId,
                setSelectedEventId,
                linkAddress,
                setLinkAddress,
                feedBackEndText,
                setFeedBackEndText,
                feedBackStartText,
                setFeedBackStartText,
                feedBackEndDate,
                setFeedBackEndDate,
                feedBackStartDate,
                setFeedBackStartDate,
                selectedFeedBackId,
                setSelectedFeedBackId,
                feedBackStepTwoId,
                setFeedBackStepTwoId,
                feedBackAnswers,
                setFeedBackAnswers,
                feedBackQuestionText,
                setFeedBackQuestionText,
                feedBackData,
                setFeedBackData,
                isInteractionModalOpen,
                setIsInteractionModalOpen,
                selectedTravelId,
                setSelectedTravelId,
                travelTitle,
                setTravelTitle,
                travelPlaces,
                setTravelPlaces,
                travelContent,
                setTravelContent,
                travelGeo,
                setTravelGeo,
                travelTags,
                setTravelTags,
                travelTime,
                setTravelTime,
                travelCoverId,
                setTravelCoverId,
                travelCover,
                setTravelCover,
                travelMediaId,
                setTravelMediaId,
                travelMedia,
                setTravelMedia,
                isNoticeModalOpen,
                setIsNoticeModalOpen,
                feedBackTitle,
                setFeedBackTitle,
                isAdminModalOpen,
                setIsAdminModalOpen,
                galleryMediaId,
                setGalleryMediaId,
                galleryMedia,
                setGalleryMedia,
                galleryTags,
                setGalleryTags,
                galleryColor,
                setGalleryColor,
                galleryIcon,
                setGalleryIcon,
                galleryDescription,
                setGalleryDescription,
                galleryTitle,
                setGalleryTitle,
                selectedGalleryId,
                setSelectedGalleryId,
                discountTitle,
                setDiscountTitle,
                discountDescription,
                setDiscountDescription,
                discountLinkUrl,
                setDiscountLinkUrl,
                discountLinkTitle,
                setDiscountLinkTitle,
                discountLinks,
                setDiscountLinks,
                discountTags,
                setDiscountTags,
                selectedDiscountId,
                setSelectedDiscountId,
                discountCoverId,
                setDiscountCoverId,
                discountCover,
                setDiscountCover,
                discountMedia,
                setDiscountMedia,
                discountMediaId,
                setDiscountMediaId,
                selectedAdId,
                setSelectedAdId,
                adPriority,
                setAdPriority,
                adLink,
                setAdLink,
                adTags,
                setAdTags,
                adPosition,
                setAdPosition,
                adLimit,
                setAdLimit,
                adStartDate,
                setAdStartDate,
                adEndDate,
                setAdEndDate,
                adTitle,
                setAdTitle,
                adDescription,
                setAdDescription,
                adCover,
                setAdCover,
                adCoverId,
                setAdCoverId,
                adNumOfSlide,
                setAdNumOfSlide,
                titleOfLink,
                setTitleOfLink,
                newstitleUrl,
                setNewstitleUrl,
                eventLinktitleUrl,
                setEventLinktitleUrl,
                tableData,
                setTableData,
                titleInput,
                setTitleInput,
                dataInput,
                setDataInput,
            }}
        >
            {children}
        </context.Provider>
    );
};

export default GlobalState;
